export default __webpack_public_path__ + "static/media/amazon-echodot.693a9c6f.jpg";